import dayjs from 'dayjs';

export const isFutureDate = (date) => {
  return dayjs(date).isAfter(dayjs(), 'd');
};

export const DATETIMEFORMAT = 'YYYY-MM-DD HH:mm:ss';
